export default __webpack_public_path__ + "static/media/icon_user.6fc9ed0b.svg";